module.exports = __webpack_public_path__ + "static/media/token-preview-fireworks.1871b27c.png";